import Vue from "vue"
import VueRouter from "vue-router"
import App from "./App.vue"
import { BootstrapVue, IconsPlugin } from "bootstrap-vue"
import router from "./router/router"
import store from "./store"
import VueResource from "vue-resource"
import Toasted from "vue-toasted"
import money from "v-money"
import AuthService from "./services/auth"

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Toasted, {
  duration: 1500,
  position: "bottom-right",
  theme: "toasted-primary",
  iconPack: "fontawesome",
})
Vue.use(money, { precision: 2 })

const API_URL = "https://api.franqueados.codefysaas.com.br/api"

Vue.http.options.root = API_URL

Vue.http.interceptors.push((request, next) => {
  const user = JSON.parse(localStorage.getItem("user"))

  if (user) {
    request.headers.set("Content-Type", "application/json")
    request.headers.set("Authorization", `Bearer ${user.access_token}`)
  }

  next()
})

let allowRefresh = true

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (allowRefresh && response.status === 401) {
      allowRefresh = false

      return AuthService.refresh().then(
        (response) => {
          localStorage.setItem("user", JSON.stringify(response.body))
          request.headers.set(
            "Authorization",
            `Bearer ${response.body.access_token}`
          )

          return Vue.http(request).then((data) => {
            return data
          })
        },
        () => {
          AuthService.logout()
          return router.push({ path: "/login" })
        }
      )
    }
  })
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
